import { z } from 'zod';
/**
 * Input schema for `PATCH /organizations/:slug/settings/business-hours`.
 *
 * `businessHoursJson` is typed as `z.unknown()` — the schema accepts any
 * JSON-serialisable value at the HTTP boundary. Structural validation
 * (day keys, time-range format, overlap detection) is delegated to the
 * `BusinessHours` domain VO via `BusinessHours.fromJSON()` inside the
 * use case. This separation keeps the schema layer thin and avoids
 * duplicating complex domain rules in the validator package.
 *
 * `.strict()` rejects extra top-level keys so that callers cannot smuggle
 * additional fields past the validation boundary.
 */
export const setBusinessHoursSchema = z
    .object({
    // z.unknown() alone accepts `undefined` (i.e. a missing key would pass).
    // The refine ensures the key is explicitly present in the payload — callers
    // must supply businessHoursJson even if they set it to null.
    businessHoursJson: z.unknown().refine((v) => v !== undefined, {
        message: 'businessHoursJson is required',
    }),
})
    .strict();
//# sourceMappingURL=business-hours.schema.js.map